import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelServicesService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // this is being commented because columns will be downloaded which are available in the display
    // const myDataJson = this.getDownloadData(json);  
    const myDataJson = json.map(s=>Object.assign(s));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(myDataJson);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  getDownloadData(json: any[]) {
    json.forEach((element,i) => {
      if(json[i].hasOwnProperty('totalCount')){
        delete json[i]['totalCount'];
      }
      if(json[i].hasOwnProperty('CreatedOn')){
        delete json[i]['CreatedOn'];
      }
      if(json[i].hasOwnProperty('createdOn')){
        delete json[i]['createdOn'];
      }
      if(json[i].hasOwnProperty('updatedBy')){
        delete json[i]['updatedBy'];
      }
      if(json[i].hasOwnProperty('updatedOn')){
        delete json[i]['updatedOn'];
      }
      if(json[i].hasOwnProperty('CreatedBy')){
        delete json[i]['CreatedBy'];
      }
      if(json[i].hasOwnProperty('UpdatedBy')){
        delete json[i]['UpdatedBy'];
      }
      if(json[i].hasOwnProperty('UpdatedOn')){
        delete json[i]['UpdatedOn'];
      }
      if(json[i].hasOwnProperty('ActiveStatusId')){
        json[i]['ActiveStatus'] = this.getActiveStatusName(json[i]['ActiveStatusId']);
        delete json[i]['ActiveStatusId'];        
      }
      if(json[i].hasOwnProperty('activeStatusId')){
        json[i]['ActiveStatus'] = this.getActiveStatusName(json[i]['activeStatusId']);
        delete json[i]['activeStatusId'];
      }
      if(json[i].hasOwnProperty('SourceType')){
        delete json[i]['SourceType'];
      }
      if(json[i].hasOwnProperty('MainSource')){
        delete json[i]['MainSource'];
      }
      if(json[i].hasOwnProperty('SMEDescription')){
        delete json[i]['SMEDescription'];
      }
      if(json[i].hasOwnProperty('countRows')){
        delete json[i]['countRows'];
      }
      if(json[i].hasOwnProperty('createdBy')){
        delete json[i]['createdBy'];
      }
      if(json[i].hasOwnProperty('createdOnDt')){
        delete json[i]['createdOnDt'];
      }
      if(json[i].hasOwnProperty('updatedOnDt')){
        delete json[i]['updatedOnDt'];
      }
      if(json[i].hasOwnProperty('NotesType')){
        delete json[i]['NotesType'];
      }
      if(json[i].hasOwnProperty('MemberId')){
        delete json[i]['MemberId'];
      }
      if(json[i].hasOwnProperty('NoteReason')){
        delete json[i]['NoteReason'];
      }
      if(json[i].hasOwnProperty('QuestionId')){
        delete json[i]['QuestionId'];
      }
      if(json[i].hasOwnProperty('AnswerId')){
        delete json[i]['AnswerId'];
      }
      if(json[i].hasOwnProperty('StartDate')){
        delete json[i]['StartDate'];
      }
      if(json[i].hasOwnProperty('EndDate')){
        delete json[i]['EndDate'];
      }
      if(json[i].hasOwnProperty('DateAdded')){
        delete json[i]['DateAdded'];
      }     
      if(json[i].hasOwnProperty('ActiveStatus')){
        delete json[i]['ActiveStatus'];
      } 
      if(json[i].hasOwnProperty('UpdatedOnDt')){
        delete json[i]['UpdatedOnDt'];
      } 
      if(json[i].hasOwnProperty('CreatedOnDt')){
        delete json[i]['CreatedOnDt'];
      } 
    });
    return json;
  }

  private getActiveStatusName(Id){
    if(Id==1){
      return 'Active'
    }
    if(Id==2){
      return 'Inactive'
    }
    if(Id==3){
      return 'Delete'
    }
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
